import type { $Fetch } from 'ofetch';
import type {
  CreateObservacaoCommand,
  ObservacaoAlunoGateway,
} from '@/application/port/out/ObservacaoAlunoGateway';
import type { ObservacaoAluno } from '@/domain/model/ObservacaoAluno';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpObservacaoAlunoGateway implements ObservacaoAlunoGateway {
  constructor(private readonly client: $Fetch) {}

  async listByAluno(alunoId: string): Promise<ObservacaoAluno[]> {
    const res = await this.client<ApiResponse<ObservacaoAluno[]>>(
      `/api/v1/alunos/${encodeURIComponent(alunoId)}/observacoes`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(command: CreateObservacaoCommand): Promise<ObservacaoAluno> {
    const res = await this.client<ApiResponse<ObservacaoAluno>>('/api/v1/observacoes', {
      method: 'POST',
      body: command,
    });
    assertApiSuccess(res);
    return res.data;
  }
}
